import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import classNames from 'classnames';

class NavBar extends Component {
  render() {
    const { isCreateEvent, isEditEvent, pathname, logo, logoWidth, logoUrl, authenticated, funnelStepper } =
      this.props;
    const logoProps = {
      src: logo,
      style: { width: logoWidth },
    };
    const slug = pathname ? pathname.split('/').pop() : '';

    return isCreateEvent || isEditEvent ? (
      <div>
        <div className="navBarV2CreateEventPlaceholder"></div>
        <div className="navBarV2CreateEvent">
          <i className="material-icons" onClick={this.props.toggleCollapsed}>
            reorder
          </i>
          <Link to={logoUrl ? logoUrl : '/'}>
            <img {...logoProps} className="logo" alt="Go4" />
          </Link>
        </div>
      </div>
    ) : (
      <nav className={classNames('navBarV2', { 'border-bottom': slug !== 'intro' })}>
        {!authenticated ? (
          <a href="https://www.go4.io/" target=" _blank" rel="noopener noreferrer">
            <img {...logoProps} className="logo" alt="Go4" />
          </a>
        ) : (
          <Link to={logoUrl ? logoUrl : '/'}>
            <img {...logoProps} className="logo" alt="Go4" />
          </Link>
        )}
        {funnelStepper && (
          <div className="navBarV2__stepper">
            <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
          </div>
        )}
        {['role', 'organization-type', 'sign-up'].includes(slug) && (
          <div className="nav-back-container">
            <Link to={funnelStepper?.backTo} className="back-btn gotham-medium-font">
              <div>Back</div>
            </Link>
          </div>
        )}
        {['athletic-trainer-sign-up'].includes(slug) && (
          <div className="nav-login-container">
            <Link to="/deeplink-sign-up" className="login-btn gotham-medium-font">
              <div>Go to App</div>
            </Link>
          </div>
        )}
      </nav>
    );
  }
}

export default NavBar;
